module.exports = __webpack_public_path__ + "img/production.994cbac4.svg";